import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.date.to-string.js";
import React from 'react';
import { Button, Dialog, Flex, HelpText, Link, Notice, Select, Text, TextInput, createForm, useId, useToasts } from '@applyboard/crystal-ui';
import { convertTimelessDateStrToLocalDate } from "../../../../utils/dates";
import { IntakeStatus, ProgramType, generateIntakeOptions, useApplication, useCreateSelfServeDeferralRequest, useIntakes, useLegacyApplication } from "../../data";
import { validateEslIntake } from "../../utils";
import { SuccessMessage } from "../../../../components/SuccessMessage";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
var _createForm = createForm(),
  Form = _createForm.Form,
  Field = _createForm.Field,
  useFieldValues = _createForm.useFieldValues;
export var RequestDeferralDialog = function RequestDeferralDialog(props) {
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useLegacyApplication = useLegacyApplication(),
    legacyApplication = _useLegacyApplication.legacyApplication;
  var _useIntakes = useIntakes(),
    intakes = _useIntakes.intakes;
  var academicProgram = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Main;
  });
  var eslProgram = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Esl;
  });
  var eslIntakes = intakes.filter(function (intake) {
    return intake.programType === ProgramType.Esl && filterFutureIntakes({
      intakeDateStr: intake.startDate,
      selectedIntake: eslProgram === null || eslProgram === void 0 ? void 0 : eslProgram.intake.startDate,
      intakeStatus: intake.intakeStatus
    });
  });
  var academicIntakes = intakes.filter(function (intake) {
    return intake.programType === ProgramType.Main && filterFutureIntakes({
      intakeDateStr: intake.startDate,
      selectedIntake: academicProgram === null || academicProgram === void 0 ? void 0 : academicProgram.intake.startDate,
      intakeStatus: intake.intakeStatus
    });
  });
  var noFutureIntakes = !(eslIntakes !== null && eslIntakes !== void 0 && eslIntakes.filter(function (intake) {
    return intake.startDate !== (eslProgram === null || eslProgram === void 0 ? void 0 : eslProgram.intake.startDate);
  }).length) && !(academicIntakes !== null && academicIntakes !== void 0 && academicIntakes.filter(function (intake) {
    return intake.startDate !== (academicProgram === null || academicProgram === void 0 ? void 0 : academicProgram.intake.startDate);
  }).length);
  var deferralFormId = useId();
  var _useCreateSelfServeDe = useCreateSelfServeDeferralRequest(),
    createSelfServeRequest = _useCreateSelfServeDe.createSelfServeRequest,
    isCreatingSelfServeRequest = _useCreateSelfServeDe.isCreatingSelfServeRequest,
    createdSelfServeRequest = _useCreateSelfServeDe.createdSelfServeRequest,
    resetCreateSelfServeRequest = _useCreateSelfServeDe.resetCreateSelfServeRequest;
  var toasts = useToasts();
  if (createdSelfServeRequest) {
    return _jsx(ResultDialog, {
      isOpen: props.isOpen,
      onOpenChange: props.onOpenChange,
      resetCreateSelfServeRequest: resetCreateSelfServeRequest
    });
  }
  return _jsxs(Dialog, {
    open: props.isOpen,
    onOpenChange: props.onOpenChange,
    size: "md",
    children: [_jsx(Dialog.Heading, {
      children: noFutureIntakes ? 'No Future Intakes Available' : 'Request Deferral'
    }), _jsx(Dialog.Content, {
      children: noFutureIntakes ? _jsx(NoFutureIntakesContent, {
        studentId: application.student.id
      }) : _jsx(Form, {
        defaultValues: {
          eslIntake: (eslProgram === null || eslProgram === void 0 ? void 0 : eslProgram.intake.startDate) || '',
          academicIntake: (academicProgram === null || academicProgram === void 0 ? void 0 : academicProgram.intake.startDate) || '',
          visaStatus: 'refused',
          reasonForDeferral: 'deferral_visa_related',
          deferralDetails: ''
        },
        onSubmit: function onSubmit(values) {
          var _eslIntakes$find, _academicIntakes$find;
          // TODO: Will need to use intake IDs for the BE integration with https://applyboard.atlassian.net/browse/AWA-4868
          var eslIntakeId = (_eslIntakes$find = eslIntakes.find(function (intake) {
            return intake.programType === ProgramType.Esl && intake.startDate === values.eslIntake;
          })) === null || _eslIntakes$find === void 0 ? void 0 : _eslIntakes$find.intakeId;
          var academicIntakeId = (_academicIntakes$find = academicIntakes.find(function (intake) {
            return intake.programType === ProgramType.Main && intake.startDate === values.academicIntake;
          })) === null || _academicIntakes$find === void 0 ? void 0 : _academicIntakes$find.intakeId;
          createSelfServeRequest({
            applicationId: application.id,
            eslProgramId: eslProgram === null || eslProgram === void 0 ? void 0 : eslProgram.programId,
            eslIntake: Number(eslIntakeId),
            academicProgramId: academicProgram === null || academicProgram === void 0 ? void 0 : academicProgram.programId,
            academicIntake: Number(academicIntakeId),
            visaStatus: values.visaStatus,
            reasonForDeferral: values.reasonForDeferral,
            otherReasonDetail: values.deferralDetails || undefined
          }, {
            onSuccess: function onSuccess() {
              props.onSuccess();
            },
            onError: function onError() {
              toasts.negative(new Error('Your request cannot be completed due to an error on our end. Please try again in a few minutes. If the error persists please contact our support team.'));
            }
          });
        },
        id: deferralFormId,
        children: _jsxs(Flex, {
          direction: "column",
          gap: 4,
          children: [_jsx(Notice, {
            children: "Please note that sending a deferral request does not guarantee that it will be approved."
          }), _jsx(Text, {
            variant: "bodyS",
            children: "Select future intakes below."
          }), _jsx(Field, {
            as: Select,
            label: "ESL Intake",
            name: "eslIntake",
            validate: function validate(value, _ref) {
              var values = _ref.values;
              var eslIntakeValidation = validateEslIntake({
                eslProgram: eslProgram,
                eslIntake: value,
                academicIntake: values.academicIntake
              });
              if (eslIntakeValidation !== true) {
                return eslIntakeValidation;
              }
              if (eslProgram !== null && eslProgram !== void 0 && eslProgram.intake.startDate) {
                return validateIntakeDate({
                  originalEslIntake: eslProgram === null || eslProgram === void 0 ? void 0 : eslProgram.intake.startDate,
                  originalAcademicIntake: academicProgram === null || academicProgram === void 0 ? void 0 : academicProgram.intake.startDate,
                  formValues: values
                });
              }
              return true;
            },
            disabled: !(eslProgram !== null && eslProgram !== void 0 && eslProgram.intake.startDate),
            appearance: "styled",
            children: generateIntakeOptions({
              selectedIntake: eslProgram === null || eslProgram === void 0 ? void 0 : eslProgram.intake.startDate,
              intakes: eslIntakes
            }).map(function (_ref2, index) {
              var label = _ref2.label,
                value = _ref2.value;
              return _jsx(Select.Option, {
                label: label,
                value: value
              }, index);
            })
          }), _jsx(ClosedIntakeWarning, {
            intakes: intakes,
            isEsl: true
          }), _jsx(Field, {
            as: Select,
            label: "Academic Intake",
            name: "academicIntake",
            validate: function validate(_value, _ref3) {
              var triggerValidation = _ref3.triggerValidation,
                values = _ref3.values;
              triggerValidation('eslIntake');
              return validateIntakeDate({
                originalEslIntake: eslProgram === null || eslProgram === void 0 ? void 0 : eslProgram.intake.startDate,
                originalAcademicIntake: academicProgram === null || academicProgram === void 0 ? void 0 : academicProgram.intake.startDate,
                formValues: values
              });
            },
            disabled: !academicIntakes.length,
            intent: !academicIntakes.length ? 'warning' : 'secondary',
            helpText: !academicIntakes.length ? 'No future intake is available. Please contact your ApplyBoard Representative for more information.' : undefined,
            appearance: "styled",
            children: generateIntakeOptions({
              selectedIntake: academicProgram === null || academicProgram === void 0 ? void 0 : academicProgram.intake.startDate,
              intakes: academicIntakes
            }).map(function (_ref4, index) {
              var label = _ref4.label,
                value = _ref4.value;
              return _jsx(Select.Option, {
                label: label,
                value: value
              }, index);
            })
          }), _jsx(ClosedIntakeWarning, {
            intakes: intakes,
            isEsl: false
          }), _jsxs(Field, {
            as: Select,
            label: "Visa Status",
            name: "visaStatus",
            appearance: "styled",
            children: [_jsx(Select.Option, {
              label: "Visa Not Submitted",
              value: "not_submitted"
            }), _jsx(Select.Option, {
              label: "Visa Pending",
              value: "pending"
            }), _jsx(Select.Option, {
              label: "Visa Refused",
              value: "refused"
            }), _jsx(Select.Option, {
              label: "Visa Approved",
              value: "approved"
            })]
          }), _jsx(VisaWarning, {}), _jsxs(Field, {
            as: Select,
            label: "Reason for Deferral",
            name: "reasonForDeferral",
            appearance: "styled",
            children: [_jsx(Select.Option, {
              label: "Visa related",
              value: "deferral_visa_related"
            }), _jsx(Select.Option, {
              label: "Visa interview delayed",
              value: "deferral_visa_interview_delayed"
            }), _jsx(Select.Option, {
              label: "Financial difficulties",
              value: "deferral_financial_difficulties"
            }), _jsx(Select.Option, {
              label: "Work commitment",
              value: "deferral_work_commitment"
            }), _jsx(Select.Option, {
              label: "Family commitment",
              value: "deferral_family_commitment"
            }), _jsx(Select.Option, {
              label: "Application waitlisted or program closed",
              value: "deferral_application_waitlisted_or_program_closed"
            }), _jsx(Select.Option, {
              label: "IELTS pending",
              value: "deferral_ielts_pending"
            }), _jsx(Select.Option, {
              label: "Personal reason",
              value: "deferral_personal_reason"
            }), _jsx(Select.Option, {
              label: "Medical reason",
              value: "deferral_medical_reason"
            }), _jsx(Select.Option, {
              label: "Other",
              value: "deferral_other"
            })]
          }), _jsx(DeferralReasonField, {})]
        })
      })
    }), _jsx(Dialog.Actions, {
      children: noFutureIntakes ? _jsx(Button, {
        intent: "primary",
        width: "fill",
        onClick: function onClick() {
          return props.onOpenChange(false);
        },
        children: "OK"
      }) : _jsxs(_Fragment, {
        children: [_jsx(Dialog.CloseButton, {
          width: "fill",
          children: "Cancel"
        }), _jsx(Button, {
          type: "submit",
          loading: isCreatingSelfServeRequest,
          form: deferralFormId,
          intent: "primary",
          width: "fill",
          children: "Submit"
        })]
      })
    })]
  });
};
var NoFutureIntakesContent = function NoFutureIntakesContent(_ref5) {
  var studentId = _ref5.studentId;
  return _jsxs(Text, {
    variant: "bodyS",
    children: ["There are no future intakes available for this program. If interested, you may also", ' ', _jsx(Link, {
      href: "/search/".concat(studentId),
      children: "search for other eligible programs"
    }), " for this student."]
  });
};
var validateIntakeDate = function validateIntakeDate(_ref6) {
  var originalEslIntake = _ref6.originalEslIntake,
    originalAcademicIntake = _ref6.originalAcademicIntake,
    formValues = _ref6.formValues;
  var validationMessage = 'Request cannot be submitted. Either Future ESL intake or Academic intake should be selected';
  if (!originalEslIntake) {
    return originalAcademicIntake === formValues.academicIntake ? validationMessage : true;
  }
  return originalEslIntake === formValues.eslIntake && originalAcademicIntake === formValues.academicIntake ? validationMessage : true;
};
var ClosedIntakeWarning = function ClosedIntakeWarning(_ref7) {
  var _intakes$find;
  var intakes = _ref7.intakes,
    isEsl = _ref7.isEsl;
  var _useFieldValues = useFieldValues(['academicIntake', 'eslIntake']),
    academicIntake = _useFieldValues.academicIntake,
    eslIntake = _useFieldValues.eslIntake;
  var selectedIntakeStatus = (_intakes$find = intakes.find(function (intake) {
    return intake.startDate === (isEsl ? eslIntake : academicIntake);
  })) === null || _intakes$find === void 0 ? void 0 : _intakes$find.intakeStatus;
  if (selectedIntakeStatus !== 'closed') {
    return null;
  }
  return _jsx(HelpText, {
    intent: "warning",
    showIcon: true,
    children: "Please note that this intake is currently closed, however, we will proceed to investigate the request."
  });
};
var VisaWarning = function VisaWarning() {
  var _useFieldValues2 = useFieldValues(['visaStatus']),
    visaStatus = _useFieldValues2.visaStatus;
  if (visaStatus !== 'refused') {
    return null;
  }
  return _jsx(HelpText, {
    intent: "warning",
    showIcon: true,
    children: "Please upload the visa refusal letter to the \u201CVisa Outcome\u201D requirement that will appear in the applicant requirement tab."
  });
};
var DeferralReasonField = function DeferralReasonField() {
  var _useFieldValues3 = useFieldValues(['reasonForDeferral']),
    reasonForDeferral = _useFieldValues3.reasonForDeferral;
  if (reasonForDeferral !== 'deferral_other') {
    return null;
  }
  return _jsx(Field, {
    as: TextInput,
    helpText: "The maximum length of a text message is 250 characters.",
    label: "Please provide more details on reason for deferral below",
    size: "lg",
    type: "text",
    name: "deferralDetails",
    required: "Please provide a reason for deferral.",
    validate: function validate(deferralDetails) {
      return deferralDetails.length > 250 ? 'You have exceeded the maximum number of 250 characters in the field.' : true;
    }
  });
};
function filterFutureIntakes(_ref8) {
  var intakeDateStr = _ref8.intakeDateStr,
    selectedIntake = _ref8.selectedIntake,
    intakeStatus = _ref8.intakeStatus;
  if (intakeDateStr === selectedIntake) {
    return true;
  }
  if (![IntakeStatus.OPEN, IntakeStatus.LIKELY_OPEN, IntakeStatus.WILL_OPEN, IntakeStatus.WILL_OPEN_CONDITIONALLY, IntakeStatus.CLOSED].includes(intakeStatus)) {
    return false;
  }
  var intakeDate = convertTimelessDateStrToLocalDate(intakeDateStr);
  var now = new Date();
  if (intakeDate.getFullYear() < now.getFullYear()) {
    return false;
  }
  if (intakeDate.getFullYear() > now.getFullYear()) {
    return true;
  }
  return intakeDate.getMonth() > now.getMonth();
}
var ResultDialog = function ResultDialog(_ref9) {
  var isOpen = _ref9.isOpen,
    _onOpenChange = _ref9.onOpenChange,
    resetCreateSelfServeRequest = _ref9.resetCreateSelfServeRequest;
  return _jsxs(Dialog, {
    open: isOpen,
    onOpenChange: function onOpenChange(isOpen) {
      resetCreateSelfServeRequest();
      _onOpenChange(isOpen);
    },
    children: [_jsx(Dialog.Heading, {
      children: "Deferral Request Successfully Sent"
    }), _jsx(Dialog.Content, {
      children: _jsxs(SuccessMessage, {
        children: [_jsx(Text, {
          variant: "bodyM",
          intent: "secondary",
          children: "Your request has been successfully submitted to ApplyBoard. It has been recorded on the Student Records tab."
        }), _jsx(Text, {
          variant: "bodyM",
          intent: "secondary",
          children: "Please allow our team 48-72 business hours to review your request. We ask that you do not submit any duplicate requests."
        })]
      })
    }), _jsx(Dialog.Actions, {
      children: _jsx(Button, {
        width: "fill",
        intent: "primary",
        onClick: function onClick() {
          resetCreateSelfServeRequest();
          _onOpenChange(false);
        },
        children: "OK"
      })
    })]
  });
};